<template>
  <div>
    <section class="report-title" style="padding:20px">
      <h5 id="modal-synthese___BV_modal_title_" class="modal-title">Complétude du dossier décès</h5>
      <h5>Assuré : {{ dossier.prenom }} {{ dossier.nom }}</h5>
    </section>
    <section class="report-content" style="padding: 10px 25px 10px 20px">
      <b-row class="pb-2">
        <b-col sm="12" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">1</b-badge> <b>Information décès</b></span>
            </div>
            <b-card-text class="p-1">
              <b-row>
                <b-col sm="6"><b class="d-inline-block col-sm-6">Date information décès</b> : <span class="ml-3">{{ !isEmpty(dossier.fiche_deces) ? formatDateSynthese(dossier.fiche_deces.date_information_deces) : '' }}</span></b-col>
                <b-col sm="6"><b class="d-inline-block col-sm-8">Date envoi mail/courrier d'initialisation</b> : <span class="ml-3">{{ !isEmpty(dossier.fiche_deces) ? formatDateSynthese(dossier.fiche_deces.date_courrier_initialisation) : '' }}</span></b-col>
              </b-row>
              <b-row>
                <b-col sm="6"><b class="d-inline-block col-sm-6">Origine information décès</b> : <span v-if="!isEmpty(dossier.fiche_deces) && !isEmpty(dossier.fiche_deces.source_information)" class="ml-3">{{ dossier.fiche_deces.source_information.toUpperCase() }}</span></b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <section class="report-content" style="padding: 10px 25px 10px 20px">
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">2</b-badge> <b>Identification du/des bénéficiaire(s)</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">Situation familiale</b> : <span v-if="!isEmpty(dossier.fiche_deces) && !isEmpty(dossier.fiche_deces.situation_familiale)" class="ml-3">{{ dossier.fiche_deces.situation_familiale.libelle }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Désignation de bénéficiaires</b> : <span v-if="!isEmpty(dossier.fiche_deces) && !isEmpty(dossier.fiche_deces.type_db)" class="ml-3">{{ dossier.fiche_deces.type_db[0].toUpperCase() + dossier.fiche_deces.type_db.substring(1) }}</span> <span class="ml-1" v-if="!isEmpty(dossier.fiche_deces) && dossier.fiche_deces.type_db === 'autre'">( {{ dossier.fiche_deces.type_db_autre }} )</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Cause décès</b> : <span class="ml-3" v-if="!isEmpty(dossier.fiche_deces) && dossier.fiche_deces.cause_deces === 'mort_naturelle'">Mort naturelle</span><span class="ml-3" v-if="!isEmpty(dossier.fiche_deces) && !isEmpty(dossier.fiche_deces.cause_deces) && dossier.fiche_deces.cause_deces !== 'mort_naturelle'">{{ dossier.fiche_deces.cause_deces[0].toUpperCase() + dossier.fiche_deces.cause_deces.substring(1) }}</span>
              </div>
              <div v-if="!isEmpty(dossier.fiche_deces) && dossier.fiche_deces.cause_deces === 'suicide'">
                <b style="padding-left: 15px;">Si suicide, l'assuré remplit-il les conditions d'ancienneté prévues ?</b> : <span class="ml-3">{{ dossier.fiche_deces.has_condition_ancienete === true ? 'Oui' : 'Non' }}</span>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">3</b-badge> <b>Garanties souscrites</b></span>
            </div>
            <b-card-text class="p-1">
              <b-form-checkbox v-model="dossier.fiche_deces.has_capital_deces" name="checkbox-has_capital_deces" disabled>
                Capital décès
              </b-form-checkbox>
              <b-form-checkbox class="ml-4" v-model="dossier.fiche_deces.has_majoration_accident" disabled>
                Majoration accident
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_capital_optionnel" disabled>
                Capital optionnel
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_majorations_familiales" disabled>
                Majorations familiales
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_rente_conjoint_ocirp" disabled>
                Rente conjoint (viagère / temporaire) OCIRP
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_rente_conjoint_chorum" disabled>
                Rente conjoint (viagère / temporaire) Chorum
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_rente_substitutive_conjoint" disabled>
                Rente substitutive de conjoint (OCIRP)
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_frais_obseques" disabled>
                Frais d'obsèques
              </b-form-checkbox><br>
              <b-form-checkbox v-model="dossier.fiche_deces.has_capital_deces_famille" disabled>
                Capital décès famille
              </b-form-checkbox><br>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <section class="report-content" style="padding: 10px 25px 10px 20px">
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">4</b-badge> <b>Concernant l'assuré</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">Déclaration de décès</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_declaration_deces) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Acte de décès</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_acte_deces) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Certificat médical post-mortem</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_certificat_post_mortem) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">PV de la gendarmerie</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_pv_gendarmerie) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Dernier avis d'imposition</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_dernier_avis_imposition) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Attestation période activité</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_attestation_periode_activite) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Photocopie 12 BS</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_photocopie_12_bs) }}</span>
              </div>
              <div class="pl-3">
                <span class="mr-2"><b>Période du</b></span>{{ formatDateSynthese(dossier.fiche_deces.date_bs_periode_du) }}<span class="ml-2 mr-2"> <b>au</b> </span>{{ formatDateSynthese(dossier.fiche_deces.date_bs_periode_au) }}
              </div>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">5</b-badge> <b>Concernant la situation familiale</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">Livret de famille</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_livret_famille) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Acte de notoriété mention PACS</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_acte_notoriete_mention_pacs) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Extrait acte de naissance (assuré)</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_extrait_acte_naissance) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Attestation Tribunal Instance PACS</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_attestation_tribunal_instance_pacs) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Attestation PACS non dénoncé</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_attestation_pacs_non_denonce) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Attestation de concubinage</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_attestation_concubinage) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Justificatif de domicile commun</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_document_justificatif_domicile_commun) }}</span>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <section class="report-content" style="padding: 10px 25px 10px 20px">
      <b-row class="pb-2">
        <b-col sm="12" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">6</b-badge> <b>Concernant les bénéficiaires du capital</b></span>
            </div>
            <b-card-text class="p-1">
              <b-row class="mb-2 pl-3 pr-3">
                <b-col sm="3"><b>Nom</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="beneficiaire.id" >
                  <b>{{ beneficiaire.prenom+' '+beneficiaire.nom }}</b><br>
                  <span class="smaller" v-html="getCapitalDecesLibelle(beneficiaire)"></span><br>
                  <span class="smaller" v-html="getAllocationsLibelle(beneficiaire)"></span>
                </b-col>
              </b-row>
              <b-row class="synthese-even pl-3 pr-3">
                <b-col sm="3"><b>RIB</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'rib'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_rib) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd pl-3 pr-3">
                <b-col sm="3"><b>Justificatif de domicile</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'jd'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_justificatif_domicile) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even pl-3 pr-3">
                <b-col sm="3"><b>Pièce d'identité</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'pi'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_piece_identite) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd pl-3 pr-3">
                <b-col sm="3"><b>Jugement de tutelle</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'jt'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_jugement_tutelle) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even pl-3 pr-3">
                <b-col sm="3"><b class="text-danger">Date connaissance <br> adresse bénéficiaire</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ca'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_connaissance_adresse_beneficiaire) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd pl-3 pr-3">
                <b-col sm="3"><b>Facture acquittée des frais d'obsèques</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'jt'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_facture_acquittee_frais_obseque) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even pl-3 pr-3" v-if="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_capital_champ_libre1)">
                <b-col sm="3"><b>{{ dossier.deces_beneficiaire[0].libelle_capital_champ_libre1 }}</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ca'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_champ_libre1) }}
                </b-col>
              </b-row>
              <b-row :class="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_capital_champ_libre1) ? 'synthese-odd pl-3 pr-3' : 'synthese-even pl-3 pr-3'" v-if="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_capital_champ_libre2)">
                <b-col sm="3"><b>{{ dossier.deces_beneficiaire[0].libelle_capital_champ_libre2 }}</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ca'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_capital_champ_libre2) }}
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <section class="report-content" style="padding: 30px 25px 10px 20px">
      <b-row class="pb-2">
        <b-col sm="12" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">7</b-badge> <b>Concernant les bénéficiaires de rente éducation et rente conjoint</b></span>
            </div>
            <b-card-text class="p-1">
              <b-row class="mb-2 pl-3 pr-3">
                <b-col sm="3"><b>Nom</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="beneficiaire.id" >
                  <b>{{ beneficiaire.prenom+' '+beneficiaire.nom }}</b><br>
                  <span class="smaller" v-html="getRentesLibelle(beneficiaire)"></span>
                </b-col>
              </b-row>
              <b-row class="synthese-even pl-3 pr-3">
                <b-col sm="3"><b>RIB</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ribr'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_rib) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd pl-3 pr-3">
                <b-col sm="3"><b>Justificatif de domicile</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'jdr'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_justificatif_domicile) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even pl-3 pr-3">
                <b-col sm="3"><b>Extrait acte de naissance</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'an'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_extrait_acte_naissance) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd pl-3 pr-3">
                <b-col sm="3"><b>Pièce d'identité</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'pir'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_piece_identite) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even pl-3 pr-3">
                <b-col sm="3"><b>Certificat de scolarité</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'cs'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_certificat_scolarite) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd pl-3 pr-3">
                <b-col sm="3"><b>Attestation SS étudiant</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'sse'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_attestation_ss_etudiant) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even pl-3 pr-3">
                <b-col sm="3"><b>Contrat d'apprentissage</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'cap'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_contrat_apprentissage) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd pl-3 pr-3">
                <b-col sm="3"><b>Jugement de tutelle</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'jtr'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_jugement_tutelle) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even pl-3 pr-3">
                <b-col sm="3"><b>Attestation inscription <br> Pôle Emploi</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'pe'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_attestation_inscription_pole_emploi) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd pl-3 pr-3">
                <b-col sm="3"><b>Carte d'invalidité / Attest. MDPH</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ci'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_carte_invalidite_mdph) }}
                </b-col>
              </b-row>
              <b-row class="synthese-even pl-3 pr-3">
                <b-col sm="3"><b>Attest. Rente substitutive de conjoint</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'rsc'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_attestation_rente_substitutive_conjoint) }}
                </b-col>
              </b-row>
              <b-row class="synthese-odd pl-3 pr-3" v-if="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_rente_champ_libre1)">
                <b-col sm="3"><b>{{ dossier.deces_beneficiaire[0].libelle_rente_champ_libre1 }}</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ca'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_champ_libre1) }}
                </b-col>
              </b-row>
              <b-row :class="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_rente_champ_libre1) ? 'synthese-even pl-3 pr-3' : 'synthese-odd pl-3 pr-3'" v-if="!isEmpty(dossier.deces_beneficiaire) && !isEmpty(dossier.deces_beneficiaire[0].libelle_rente_champ_libre2)">
                <b-col sm="3"><b>{{ dossier.deces_beneficiaire[0].libelle_rente_champ_libre2 }}</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="'ca'+beneficiaire.id" >
                  {{ formatDateSynthese(beneficiaire.date_document_rente_champ_libre2) }}
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
  import { isEmpty } from '@/utils/fileHelper';
  import VueHtml2pdf from "vue-html2pdf";

  export default {
    name: "SyntheseCompletude",
    components: {
      VueHtml2pdf
    },
    data() {
      return {
        isEmpty
      }
    },
    props: ['dossier', 'allocationsOptions', 'rentesOptions', 'capitalOptions'],
    created() {
    },
    mounted() {
    },
    methods: {
      formatDateSynthese(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "--/--/----";
      },
      getRentesLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.rentes)) {
          for (let rente of this.rentesOptions) {
            if (beneficiaire.rentes.indexOf(rente.code) > -1) {
              libelle = libelle + rente.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
      getCapitalDecesLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.capital)) {
          for (let capital of this.capitalOptions) {
            if (beneficiaire.capital.indexOf(capital.code) > -1) {
              libelle = libelle + capital.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
      getAllocationsLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.allocations)) {
          for (let allocation of this.allocationsOptions) {
            if (beneficiaire.allocations.indexOf(allocation.code) > -1) {
              libelle = libelle + allocation.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
    }
  }

</script>
